<template>

    <div>
        <el-form :inline="true" :model="query" class="query-form" size="mini">
            <el-form-item class="query-form-item">
                <el-input v-model="query.tracking" placeholder="物流单号"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button-group style="display: flex;align-items: center;">
                    <el-button type="primary" icon="el-icon-refresh" @click="getList"></el-button>
                    <el-button type="primary" icon="search" @click="onSubmit">查询</el-button>
                    <el-button type="primary" @click.native="handleForm(null,null)">新增</el-button>
                    <el-button type="primary" @click="Temdownload">示例模板下载</el-button>
                    <div>
                        <upload ext="xls" title="批量上传" @on-select="onSelectPicFle" :size="716800"></upload>
                    </div>
                    <el-button type="primary" @click="Temdownload2">示例模板二下载</el-button>
                    <div>
                        <upload ext="xls,xlsx" title="模板二批量上传" @on-select="onSelectPicFle" :size="1024*1024*5"></upload>
                    </div>

                    <!-- <el-button type="primary" @click="BatchUpload">批量上传</el-button> -->
                </el-button-group>
            </el-form-item>
        </el-form>
        <el-table v-loading="loading" :data="list" style="width: 100%;">

            <el-table-column label="ID" prop="id" fixed width="50">
            </el-table-column>

            <el-table-column label="运单号" prop="tracking" :show-overflow-tooltip="true">
            </el-table-column>

            <el-table-column label="类型" prop="freight_type_name" :show-overflow-tooltip="true">
            </el-table-column>

            <el-table-column label="Zip Name">
                <template slot-scope="scope">
                    <a :href="scope.row.zip_url">{{scope.row.zip_name}}</a>
                </template>
            </el-table-column>

            <el-table-column label="添加人" prop="create_user">
            </el-table-column>
            <el-table-column label="物流公司" prop="logistics_company_name">
            </el-table-column>

            <el-table-column label="操作" fixed="right" width="230">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click.native="handleForm(scope.$index, scope.row)">编辑
                    </el-button>
                    <el-button type="text" size="small" @click.native="handleDel(scope.$index, scope.row)">删除
                    </el-button>
                    <div style="display: inline-block;margin-left: 10px;">
                        <upload ext="zip" :id="scope.row.id" title="上传压缩包" @on-select="onSelectPicZip" :size="716800"></upload>
                    </div>
                    <!-- <el-button type="text" v-if="!scope.row.zip_name" size="small" @click.native="handleupload(scope.$index, scope.row)">上传压缩包
                    </el-button> -->
                </template>
            </el-table-column>
        </el-table>

        <el-pagination :page-size="query.limit" @current-change="handleCurrentChange" layout="prev, pager, next"
            :total="total">
        </el-pagination>

        <!--表单-->
        <el-dialog :title="formMap[formName]" :visible.sync="formVisible" :before-close="hideForm" width="85%"
            top="5vh">
            <el-form :model="formData" :rules="formRules" ref="dataForm">
                <el-form-item label="物流公司" prop="logistics_company_id">
                    <el-select v-model="formData.logistics_company_id" placeholder="请选择">
                        <el-option v-for="(item,index) in TransporterList" :key="index" :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="物流单号" prop="tracking">
                    <el-input :disabled="disabled" v-model="formData.tracking" style="width: 80%;" auto-complete="off">
                    </el-input>
                </el-form-item>

                <el-form-item label="压缩文件" prop="zip_path">
                    <div>
                        <el-input style="width: 80%;" size="small" v-model="formData.zip_path" auto-complete="off"
                            placeholder="压缩文件"></el-input>

                        <upload ext="zip" :size="716800" @on-select="onSelectPic"></upload>

                    </div>

                </el-form-item>

                <!-- <el-form-item label="发船时间">

                    <el-form-item prop="freight_content[0][1].content_time" style="display: inline-block;">
                        <el-date-picker
                            v-model="formData.freight_content[0][1].content_time"
                            type="datetime"
                            size="mini"
                            placeholder="发船时间">
                        </el-date-picker>
                    </el-form-item>
                  </el-form-item>

				   <el-form-item label="发船港口">
                    <el-form-item prop="freight_content[0][1].content" style="display: inline-block;">
                        <el-input v-model="formData.freight_content[0][1].content" size="small" auto-complete="off"></el-input>
                    </el-form-item>
                  </el-form-item>

				  <el-form-item label="停靠时间">

                    <el-form-item prop="freight_content[0][2].content_time" style="display: inline-block;">
                        <el-date-picker
                            v-model="formData.freight_content[0][2].content_time"
                            type="datetime"
                            size="mini"
                           >
                        </el-date-picker>
                    </el-form-item>
                  </el-form-item> -->

                <!-- <el-form-item label="停靠港口">
                    <el-form-item prop="freight_content[0][2].content" style="display: inline-block;">
                        <el-input v-model="formData.freight_content[0][2].content" size="small" auto-complete="off"></el-input>
                    </el-form-item>
                  </el-form-item> -->

                <div style="border: 1px solid #DCDFE6;padding: 20px;margin-bottom: 20px;"
                    v-for="(item,index) in formData.freight_content" :key="index">
                    <el-form-item label="物流类型" required>
                        <el-form-item prop="freight_type">
                            <el-radio-group v-model="formData.freight_type">
                                <el-radio :label="1">船运</el-radio>
                                <el-radio :label="2">空运</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-form-item>
                    <el-form-item label="运输状态">
                        <el-form-item prop="state" style="display: inline-block;">
                            <el-input v-model="item.state" size="small" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-form-item>
                    <el-form-item label="运输位置">
                        <el-form-item prop="position" style="display: inline-block;">
                            <el-input v-model="item.position" size="small" auto-complete="off"></el-input>
                        </el-form-item>
                    </el-form-item>
                    <el-form-item label="运输日期">
                        <el-form-item prop="date" style="display: inline-block;">
                            <el-date-picker v-model="item.date" type="datetime" size="mini" placeholder="运输日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="deletefreight(index)">删除 <i class="el-icon-delete"></i></el-button>
                    </el-form-item>
                </div>
                <el-form-item>
                    <el-button @click="addfreight()" type="primary">添加 <i class="el-icon-circle-plus-outline"></i>
                    </el-button>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hideForm">取消</el-button>
                <el-button type="primary" @click.native="formSubmit()" :loading="formLoading">提交</el-button>
            </div>
        </el-dialog>

    </div>





</template>

<script>
    import axios from "../../utils/axios";
    import {
        lsList,
        lsSave,
        lsDelete,
        lcList,
        lcuploadZip
    } from "../../api/ls/ls";
    import Upload from "../../components/File/Upload.vue";
    const formJson = {
        id: "",
        tracking: "",
        zip_name: "",
        zip_path: "",
        create_time: "",
        create_user: "",
        freight_type_name: "",
        freight_type: 2,
        zip_url: "",
        logistics_company_id: "",
        freight_content: [{
            "state": "",
            "position": "",
            "date": ""
        }]
    };
    export default {
        data() {
            return {
                query: {
                    tracking: "",
                    page: 1,
                    limit: 20
                },
                channelListInput: "",
                androidVersionListInput: "",
                iosVersionListInput: "",
                list: [],
                total: 0,
                loading: true,
                index: null,
                formName: null,
                formMap: {
                    add: "新增",
                    edit: "编辑"
                },
                formLoading: false,
                formVisible: false,
                formData: formJson,
                formRules: {
                    tracking: [{
                        required: true,
                        message: "请输单号",
                        trigger: "blur"
                    }],
                    logistics_company_id: [{
                        required: true,
                        message: "请选择物流公司",
                        trigger: "blur"
                    }],
                    freight_type_name: [{
                        required: true,
                        message: "请选货运方式",
                        trigger: "change"
                    }]
                },
                deleteLoading: false,
                TransporterList: [],
                disabled: false,
            };
        },
        components: {
            Upload,
            axios
        },
        methods: {
            deletefreight(index) {
                if (this.formData.freight_content.length == 1) {
                    this.$message.error("至少选择一项!");
                    return false
                }
                this.formData.freight_content.splice(index, 1)
            },
            addfreight() {
                this.formData.freight_content.push({
                    "state": "",
                    "position": "",
                    "date": ""
                })
            },
            onReset() {
                this.$router.push({
                    path: ""
                });
                this.query = {
                    tracking: "",
                    page: 1,
                    limit: 20
                };
                this.getList();
            },
            onSubmit() {
                this.$router.push({
                    path: "",
                    query: this.query
                });
                this.getList();
            },
            Temdownload() {
                let URL=axios.defaults.baseURL
                let TemHref=URL.lastIndexOf("/")
                URL=URL.substring(0,TemHref);
                window.open(URL+ '/uploads/logistics_info.xls')
                // window.open('http://192.168.1.129:8090/uploads/logistics_info.xls')
            },
            Temdownload2() {
                let URL=axios.defaults.baseURL
                let TemHref=URL.lastIndexOf("/")
                URL=URL.substring(0,TemHref);
                window.open(URL+ '/uploads/logistics_info_2.xls')
            },
            handleSizeChange(val) {
                this.query.limit = val;
                this.getList();
            },
            handleCurrentChange(val) {
                this.query.page = val;
                this.getList();
            },
            getList() {
                this.loading = true;
                lsList(this.query)
                    .then(response => {
                        this.loading = false;
                        this.list = response.data.list || [];
                        this.total = response.data.total || 0;
                    })
                    .catch(() => {
                        this.loading = false;
                        this.list = [];
                        this.total = 0;
                    });
            },
            // 删除渠道
            handleChannelListClose(index) {
                console.log(index);
                // 更改值
                this.formData.channel_list.splice(index, 1);
            },
            // 添加渠道白名单
            handleChannelListSubmit() {
                // 更改值
                if (
                    this.channelListInput &&
                    this.formData.channel_list.length < 15
                ) {
                    let arr = this.channelListInput.split(",");
                    for (let i in arr) {
                        if (
                            arr[i] !== "" &&
                            (this.formData.channel_list.length === 0 ||
                                this.formData.channel_list.indexOf(arr[i]) < 0)
                        ) {
                            this.formData.channel_list.push(arr[i]);
                        }
                    }
                    this.channelListInput = "";
                    this.$refs.channelListRef.focus();
                }
            },
            // 删除Android版本
            handleAndroidVersionListClose(index) {
                // 更改值
                this.formData.android_version_list.splice(index, 1);
            },
            // 添加Android版本
            handleAndroidVersionListSubmit() {
                // 更改值
                if (
                    this.androidVersionListInput &&
                    this.formData.android_version_list.length < 15
                ) {
                    let arr = this.androidVersionListInput.split(",");
                    for (let i in arr) {
                        let avList = this.formData.android_version_list;
                        if (
                            arr[i] !== "" &&
                            (avList.length === 0 || avList.indexOf(arr[i]) < 0)
                        ) {
                            this.formData.android_version_list.push(arr[i]);
                        }
                    }
                    this.androidVersionListInput = "";
                    this.$refs.androidVersionListRef.focus();
                }
            },
            // 删除Ios版本
            handleIosVersionListClose(index) {
                // 更改值
                this.formData.ios_version_list.splice(index, 1);
            },
            // 添加Ios版本
            handleIosVersionListSubmit() {
                // 更改值
                if (
                    this.iosVersionListInput &&
                    this.formData.ios_version_list.length < 15
                ) {
                    let arr = this.iosVersionListInput.split(",");
                    for (let i in arr) {
                        if (
                            arr[i] !== "" &&
                            (this.formData.ios_version_list.length === 0 ||
                                this.formData.ios_version_list.indexOf(arr[i]) < 0)
                        ) {
                            this.formData.ios_version_list.push(arr[i]);
                        }
                    }
                    this.iosVersionListInput = "";
                    this.$refs.iosVersionListRef.focus();
                }
            },
            // 刷新表单
            resetForm() {
                if (this.$refs["dataForm"]) {
                    // 清空字段
                    this.$refs["dataForm"].resetFields();
                    // 清空验证信息表单
                    this.$refs["dataForm"].clearValidate();
                }
            },
            // 隐藏表单
            hideForm() {
                // 更改值
                this.formVisible = !this.formVisible;
                return true;
            },
            // 显示表单
            handleForm(index, row) {
                this.formVisible = true;
                // 刷新表单
                this.resetForm();
                this.formData = JSON.parse(JSON.stringify(formJson));
                if (row !== null) {
                    this.formData = Object.assign({}, row);
                }
                this.formName = "add";
                this.disabled = false
                if (index !== null) {
                    this.index = index;
                    this.formName = "edit";
                    this.formData.freight_type = row.freight_type
                    this.freight_content = row.freight_content
                    this.disabled = true
                }
            },
            formSubmit() {
                this.$refs["dataForm"].validate(valid => {
                    if (valid) {
                        this.formLoading = true;
                        // let data = Object.assign({}, this.formData);
                        let data = {
                            "tracking": this.formData.tracking,
                            "freight_type": this.formData.freight_type,
                            "zip_path": this.formData.zip_path,
                            "freight_content": this.formData.freight_content,
                            "logistics_company_id": this.formData.logistics_company_id
                        }
                        if (this.formName == "edit") {
                            data.id = this.formData.id
                        }
                        lsSave(data, this.formName)
                            .then(response => {
                                this.formLoading = false;
                                if (response.code) {
                                    this.$message.error(response.message);
                                    return false;
                                }
                                this.$message.success("操作成功");
                                this.formVisible = false;
                                if (this.formName === "add") {
                                    // 向头部添加数据
                                    data.id = response.data.id;
                                    data.zip_name = response.data.zip_name;
                                    data.freight_type_name = response.data.freight_type_name;
                                    data.create_user = response.data.create_user;
                                    this.list.unshift(data);
                                } else {
                                    data.freight_content = response.data.freight_content;
                                    this.list.splice(this.index, 1, data);
                                }
                                this.getList();
                            })
                            .catch(() => {
                                this.formLoading = false;
                            });
                    }
                });
            },
            // 上传压缩包
            handleupload(index, row){

            },
            // 删除
            handleDel(index, row) {
                if (row.id) {
                    this.$confirm("确认删除该记录吗?", "提示", {
                            type: "warning"
                        })
                        .then(() => {
                            let para = {
                                id: row.id
                            };
                            this.deleteLoading = true;
                            lsDelete(para)
                                .then(response => {
                                    this.deleteLoading = false;
                                    if (response.code) {
                                        this.$message.error(response.message);
                                        return false;
                                    }
                                    this.$message("删除成功");
                                    // 刷新数据
                                    this.list.splice(index, 1);
                                })
                                .catch(() => {
                                    this.deleteLoading = false;
                                });
                        })
                        .catch(() => {
                            this.$message.info("取消删除");
                        });
                }
            },
            onSelectPic(filePath, filePathUrl) {
                this.formData.zip_path = filePath;
                this.formData.zip_url = '';
            },
            onSelectPicFle(fileWhy){
                if(fileWhy=='1'){
                    this.$message.success("上传成功");
                    this.getList();
                }
            },
            onSelectPicZip(filePath,filePathUrl,id){
                console.log(filePath)
                if(filePath){
                     this.deleteLoading = true;
                    let data={
                        'id':id,
                        'zip_path':filePath
                    }
                    lcuploadZip(data)
                            .then(response => {
                                this.deleteLoading = false;
                                if (response.code) {
                                    this.$message.error(response.message);
                                    return false;
                                }
                                this.$message("上传成功");
                                // 刷新数据
                                this.getList();
                            })
                            .catch(() => {
                                this.deleteLoading = false;
                            });

                }
            }
        },
        filters: {
            statusFilterType(status) {
                const statusMap = {
                    0: "gray",
                    1: "success"
                };
                return statusMap[status];
            },
            statusFilterName(status) {
                const statusMap = {
                    0: "禁用",
                    1: "正常"
                };
                return statusMap[status];
            }
        },
        mounted() {},
        created() {
            // 将参数拷贝进查询对象
            let query = this.$route.query;
            this.query = Object.assign(this.query, query);
            this.query.limit = parseInt(this.query.limit);
            // 加载表格数据
            this.getList();
            lcList()
                .then(response => {
                    this.loading = false;
                    this.TransporterList = response.data.list
                })
                .catch(() => {
                    this.loading = false;
                });
        }
    };
</script>

<style type="text/scss" lang="scss">
</style>
